import type { BreakpointType } from '@gik/core/hooks/hooks/BreakpointHooks';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { AppHeaderLogo } from '@gik/ui-legacy/gik/AppHeader/AppHeaderLogo';
import { AppHeaderNav } from '@gik/ui-legacy/gik/AppHeader/AppHeaderNav';
import { AppHeaderNavBar } from '@gik/ui-legacy/gik/AppHeader/AppHeaderNavBar';
import { AppHeaderNavMobile } from '@gik/ui-legacy/gik/AppHeader/AppHeaderNavMobile';
import { AppHeaderNavMobileDrawer } from '@gik/ui-legacy/gik/AppHeader/AppHeaderNavMobileDrawer';

export type IAppHeaderProps = {
  muted?: boolean;
  className?: string;
} & BreakpointType;

function AppHeaderComp({ breakpoint, muted }: IAppHeaderProps) {
  return (
    <AppHeaderNavBar muted={muted} breakpoint={breakpoint}>
      <AppHeaderNavMobileDrawer breakpoint={breakpoint} />
      <AppHeaderLogo breakpoint={breakpoint} />
      <AppHeaderNavMobile breakpoint={breakpoint} />
      <AppHeaderNav breakpoint={breakpoint} />
    </AppHeaderNavBar>
  );
}

export const AppHeader = withComponentErrorBoundary(AppHeaderComp);
